"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineUrl = exports.arePathsEqual = exports.parsePath = exports.stringOrObjectToString = exports.encodeParams = exports.decodeParams = void 0;
var kea_1 = require("kea");
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
function parseValue(value) {
    if (!Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
        return Number(value);
    }
    else if (value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
        return value.toLowerCase() === 'true';
    }
    else if (value !== null && value.length >= 2 && (value.match(/^\[.*\] +$/) || value.match(/^\{.*\} +$/))) {
        return value.substring(0, value.length - 1);
    }
    else if (value !== null && value.length >= 2 && (value.match(/^\[.*\]$/) || value.match(/^\{.*\}$/))) {
        try {
            return JSON.parse(value);
        }
        catch (e) {
        }
    }
    return value;
}
function serializeValue(value) {
    if (typeof value === 'object') {
        value = JSON.stringify(value);
    }
    else if (typeof value === 'string' && (value.match(/^\[.*\] *$/) || value.match(/^\{.*\} *$/))) {
        value = value + ' ';
    }
    return value;
}
function decodeParams(input, symbol) {
    if (symbol === void 0) { symbol = ''; }
    if (symbol && input.indexOf(symbol) === 0) {
        input = input.slice(1);
    }
    var ret = Object.create(null);
    for (var _i = 0, _a = input.split('&'); _i < _a.length; _i++) {
        var param = _a[_i];
        param = param.replace(/\+/g, ' ');
        var index = param.indexOf('=');
        if (index === -1) {
            if (param.length > 0) {
                ret[decodeURIComponent(param)] = null;
            }
        }
        else {
            var key = decodeURIComponent(param.slice(0, index));
            var value = decodeURIComponent(param.slice(index + 1));
            ret[key] = parseValue(value);
        }
    }
    return ret;
}
exports.decodeParams = decodeParams;
function encodeParams(obj, symbol) {
    if (symbol === void 0) { symbol = ''; }
    if (typeof obj !== 'object') {
        return '';
    }
    var string = Object.keys(obj)
        .map(function (key) {
        var value = obj[key];
        if (typeof value === 'undefined') {
            return '';
        }
        if (value === null) {
            return encodeURIComponent(key);
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(serializeValue(value));
    })
        .filter(function (k) { return k.length !== 0; })
        .join('&');
    return string.length > 0 ? symbol + string : '';
}
exports.encodeParams = encodeParams;
function stringOrObjectToString(input, symbol) {
    if (!input) {
        return '';
    }
    return typeof input === 'object' ? encodeParams(input, symbol) : input.indexOf(symbol) === 0 ? input : symbol + input;
}
exports.stringOrObjectToString = stringOrObjectToString;
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash,
    };
}
exports.parsePath = parsePath;
var _e = encodeParams;
var _d = decodeParams;
function arePathsEqual(a, b) {
    var parsedA = parsePath(a);
    var parsedB = parsePath(b);
    if (parsedA.pathname !== parsedB.pathname || parsedA.hash !== parsedB.hash) {
        return false;
    }
    var decodedSearchA = decodeParams(parsedA.search, '?');
    var decodedSearchB = decodeParams(parsedB.search, '?');
    var searchParamsA = __spreadArray([], Object.entries(decodedSearchA), true).sort();
    var searchParamsB = __spreadArray([], Object.entries(decodedSearchB), true).sort();
    if (searchParamsA.length !== searchParamsB.length) {
        return false;
    }
    for (var i = 0; i < searchParamsA.length; i++) {
        if (searchParamsA[i][0] !== searchParamsB[i][0] || !(0, fast_deep_equal_1.default)(searchParamsA[i][1], searchParamsB[i][1])) {
            return false;
        }
    }
    return true;
}
exports.arePathsEqual = arePathsEqual;
function combineUrl(url, searchInput, hashInput, encodeParams, decodeParams) {
    if (encodeParams === void 0) { encodeParams = (0, kea_1.getPluginContext)('router').encodeParams || _e; }
    if (decodeParams === void 0) { decodeParams = (0, kea_1.getPluginContext)('router').decodeParams || _d; }
    var parsedPath = parsePath(url);
    var response = {
        pathname: parsedPath.pathname,
        search: '',
        searchParams: decodeParams(parsedPath.search, '?'),
        hash: '',
        hashParams: decodeParams(parsedPath.hash, '#'),
        url: '',
    };
    if (typeof searchInput === 'object') {
        Object.assign(response.searchParams, searchInput);
    }
    else if (typeof searchInput === 'string') {
        Object.assign(response.searchParams, decodeParams(searchInput, '?'));
    }
    response.search = encodeParams(response.searchParams, '?');
    if (typeof hashInput === 'object') {
        Object.assign(response.hashParams, hashInput);
    }
    else if (typeof hashInput === 'string') {
        Object.assign(response.hashParams, decodeParams(hashInput, '#'));
    }
    response.hash = encodeParams(response.hashParams, '#');
    response.url = "".concat(response.pathname).concat(response.search).concat(response.hash);
    return response;
}
exports.combineUrl = combineUrl;
//# sourceMappingURL=utils.js.map